export default [
  {
    id: 1,
    key: 'amount',
    name: '实际消耗金额',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '元',
    fixed: true
  },
  {
    id: 2,
    key: 'newRoleRate',
    name: '新创角ROI',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      },
      {
        label: '>',
        value: '>'
      },
      {
        label: '<=',
        value: '<='
      },
      {
        label: '<',
        value: '<'
      }
    ],
    unit: '%',
    fixed: true
  },
  {
    id: 3,
    key: 'imageCreateTime',
    name: '素材新建时间',
    value: '',
    field_type: 'string',
    expression: '>',
    equalenums: [
      {
        label: '>',
        value: '>'
      },
      {
        label: '>=',
        value: '>='
      },
      {
        label: '<',
        value: '<'
      },
      {
        label: '<=',
        value: '<='
      }
    ],
    unit: '天',
    fixed: false
  },
  {
    id: 4,
    key: 'roi1',
    name: '1日roi',
    value: '',
    field_type: 'string',
    expression: '>',
    equalenums: [
      {
        label: '>',
        value: '>'
      },
      {
        label: '>=',
        value: '>='
      },
      {
        label: '<',
        value: '<'
      },
      {
        label: '<=',
        value: '<='
      }
    ],
    unit: '%',
    fixed: true
  },
  {
    id: 5,
    key: 'roi3',
    name: '3日roi',
    value: '',
    field_type: 'string',
    expression: '>',
    equalenums: [
      {
        label: '>',
        value: '>'
      },
      {
        label: '>=',
        value: '>='
      },
      {
        label: '<',
        value: '<'
      },
      {
        label: '<=',
        value: '<='
      }
    ],
    unit: '%',
    fixed: true
  },
  {
    id: 6,
    key: 'roi7',
    name: '7日roi',
    value: '',
    field_type: 'string',
    expression: '>',
    equalenums: [
      {
        label: '>',
        value: '>'
      },
      {
        label: '>=',
        value: '>='
      },
      {
        label: '<',
        value: '<'
      },
      {
        label: '<=',
        value: '<='
      }
    ],
    unit: '%',
    fixed: true
  },
  {
    id: 7,
    key: 'planCount',
    name: '计划数',
    value: '',
    field_type: 'string',
    expression: '>',
    equalenums: [
      {
        label: '>',
        value: '>'
      },
      {
        label: '>=',
        value: '>='
      },
      {
        label: '<',
        value: '<'
      },
      {
        label: '<=',
        value: '<='
      }
    ],
    unit: '',
    fixed: false
  }
]
